import { BadgeProps, Badge as MuiBadge, styled } from '@mui/material';

const StyledBadge = styled(MuiBadge)(() => ({
  '& .MuiBadge-badge': {
    right: 5,
    top: 5,
    border: '2px solid var(--surface-bg-overlay-color)'
  }
}));

export function Badge({ children, ...props }: BadgeProps) {
  return <StyledBadge {...props}>{children}</StyledBadge>;
}
